export class Card {
  id: number;
  sixLetterCode: string;
  amount: any;
  currentMarket: number;
  swap: string;
  index: number;

  constructor(sixLetterCode: string) {
    this.sixLetterCode = sixLetterCode;
  }
}

export class Cards {
  id: number;
  sixLetterCode: string;
  card: Card;
  priceBid: number;
  priceAsk: number;

}
